import React, { useCallback } from 'react'
import Form from '../Form3'
import { withTheme } from 'styled-components'

// const CompWrapper = styled.div`
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.marginTop && `margin-top: ${p.theme.standardComponent.marginTop}${p.theme.standardComponent.marginUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.marginBottom && `margin-bottom: ${p.theme.standardComponent.marginBottom}${p.theme.standardComponent.marginUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.marginLeft && `margin-left: ${p.theme.standardComponent.marginLeft}${p.theme.standardComponent.marginUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.marginRight && `margin-right: ${p.theme.standardComponent.marginRight}${p.theme.standardComponent.marginUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.paddingTop && `padding-top: ${p.theme.standardComponent.paddingTop}${p.theme.standardComponent.paddingUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.paddingBottom && `padding-bottom: ${p.theme.standardComponent.paddingBottom}${p.theme.standardComponent.paddingUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.paddingLeft && `padding-left: ${p.theme.standardComponent.paddingLeft}${p.theme.standardComponent.paddingUnit};` }
//   ${ p => p.theme && p.theme.standardComponent && p.theme.standardComponent.paddingRight && `padding-right: ${p.theme.standardComponent.paddingRight}${p.theme.standardComponent.paddingUnit};` }
// `

let StandardComponent = withTheme((props) => {
  const {
    nodeId,
    nodes,
    pubSub,
    confirmPubSub,
    errors,
    warnings,
    effects,
    match,
    formNodes,
    formId,
    effectsLoading,
    components,
    rootId,
    templateId,
    save,
    viewData,
    formData,
    data,
    dispatchEvent,
    subscribe,
    isInputDisabled,
    loadForm,
    setActiveFormSection,
    activeFormSection,
    push,
    replace,
    goBack,
    login,
    connections,
    changeStatus,
    theme,
    queryParams,
    currentState,
    user,
    userPersistentProfile,
    setUserPersistentProfile,
    validationMessage,
    validationErrors,
    confirmValidationMessage,
    stop,
    setStop,
    download,
    configuration,
    htmlTemplates,
    addNote,
    authStatus,
    cancelLogin,
    formProcess,
    collect,
    loginSession,
    runEffect: _runEffect
  } = props;
  let node = nodes[nodeId]

  const _dispatchEvent = (event, context) => {
    const { extra = {} } = node;
    const { events = {} } = extra;
    if (events[event]) {
      let _context = typeof context === 'string' ? { value: context} : context

      dispatchEvent({ pageType: 'view', pageId: rootId, nodeId, event, context: { ..._context, ...data } })
    }
  }; //, [node,data])

  const runEffect = useCallback(({ source, context, effectId }) => {
    _runEffect({  source, context : {...context,document: viewData}, pageType: 'view', componentId: nodeId, pageId: rootId, effectId })
  }, [_runEffect, nodeId, rootId,viewData])

  if (!node) {
    return null
  }

  /** Check for hidden components */
  if(node.hideComponent) {
    return null
  }

  /**
   * Check for content types. Then we are currently rendering a template and this is where we shall inject the "real" view
   * 
   */
  let structure = node.structure;
  if (node.type === "Content") {
    const rootNode = nodes[rootId]

    structure = rootNode.structure;
    //node = nodes[rootId]
  }

  const { type, extra = {}, disableComponent } = node;
  
  let children = [];

  if (structure) {
    structure.forEach(nodeId => {
      return children.push(
        <StandardComponent
          nodeId={nodeId}
          key={nodeId}
          errors={errors}
          warnings={warnings}
          nodes={nodes}
          match={match}
          pubSub={pubSub}
          confirmPubSub={confirmPubSub}
          formNodes={formNodes}
          formId={formId}
          effects={effects}
          effectsLoading={effectsLoading}
          components={components}
          rootId={rootId}
          templateId={templateId}
          save={save}
          viewData={viewData}
          formData={formData}
          runEffect={props.runEffect}
          data={data}
          dispatchEvent={dispatchEvent}
          subscribe={subscribe}
          isInputDisabled={isInputDisabled}
          setActiveFormSection={setActiveFormSection}
          loadForm={loadForm}
          activeFormSection={activeFormSection}
          push={push}
          formProcess={formProcess}
          replace={replace}
          goBack={goBack}
          login={login}
          connections={connections}
          changeStatus={changeStatus}
          theme={theme}
          queryParams={queryParams}
          user={user}
          userPersistentProfile={userPersistentProfile}
          setUserPersistentProfile={setUserPersistentProfile}
          currentState={currentState}
          validationMessage={validationMessage}
          validationErrors={validationErrors}
          confirmValidationMessage={confirmValidationMessage}
          stop={stop}
          setStop={setStop}
          download={download}
          configuration={configuration}
          htmlTemplates={htmlTemplates}
          addNote={addNote}
          authStatus={authStatus}
          cancelLogin={cancelLogin}
          collect={collect}
          loginSession={loginSession}
        />
      )
    })
  }

  const Component = type === 'Form' ? Form : components[type]

  if (!Component) {
    return <div>Component not supported</div>
  }

  const { name } = extra

  // theme insert here


  // return <div>test</div>
  const component2Render = <Component
    //id={name ? name : nodeId}
    id={nodeId}
    configuration={configuration}
    name={name}
    children={children}
    extra={extra}
    rootId={rootId}
    templateId={templateId}
    nodes={nodes}
    nodeId={nodeId}
    components={components}
    save={save}
    match={match}
    document={viewData}
    viewData={viewData}
    formData={formData}
    data={data}
    dispatchEvent={_dispatchEvent}
    subscribe={subscribe}
    value={viewData[node.name ? node.name : node.id]}
    effects={effects}
    effectsLoading={effectsLoading}
    runEffect={runEffect}
    pubSub={pubSub}
    confirmPubSub={confirmPubSub}
    disabled={isInputDisabled || disableComponent}
    isInputDisabled={isInputDisabled}
    errors={errors}
    warnings={warnings}
    loadForm={loadForm}
    formNodes={formNodes}
    formId={formId}
    setActiveFormSection={setActiveFormSection}
    activeFormSection={activeFormSection}
    push={push}
    replace={replace}
    goBack={goBack}
    login={login}
    connections={connections}
    changeStatus={changeStatus}
    theme={theme}
    baseStyle={theme['standardComponent']}
    queryParams={queryParams}
    currentState={currentState}
    user={user}
    userPersistentProfile={userPersistentProfile}
    setUserPersistentProfile={setUserPersistentProfile}
    validationMessage={validationMessage}
    validationErrors={validationErrors}
    confirmValidationMessage={confirmValidationMessage}
    stop={stop}
    setStop={setStop}
    download={download}
    htmlTemplates={htmlTemplates}
    addNote={addNote}
    authStatus={authStatus}
    origin="portal"
    pageType="view"
    cancelLogin={cancelLogin}
    formProcess={formProcess}
    collect={collect}
    loginSession={loginSession}

  />

  return component2Render
})

export default StandardComponent